import { filter } from 'fp-ts/Array'
import { type Eq } from 'fp-ts/Eq'
import { flow, pipe } from 'fp-ts/function'
import { fromNullable, match } from 'fp-ts/Option'
import { fromArray } from 'fp-ts/Set'

import { planKindToPageFlag } from './plan/utils'
import { type PlanKind, type PlansPageFlag, PlansPageFlags } from './types'

export const parseFlags = (enabledFlags?: string[]): Set<PlansPageFlag> =>
  pipe(
    enabledFlags,
    fromNullable,
    match(() => [], flow(filter(isPlansPageFlag))),
    fromArray(eqPlansPageFlag),
  )

const isPlansPageFlag = (flag: string): flag is PlansPageFlag =>
  Object.values(PlansPageFlags)
    .map(flag => flag.toString())
    .includes(flag)

const eqPlansPageFlag: Eq<PlansPageFlag> = {
  equals: (a, b) => a === b,
}

export const isCtaDisabled =
  (plansPageFlags: Set<PlansPageFlag>) =>
  (planKind: PlanKind): boolean =>
    plansPageFlags.has(planKindToPageFlag(planKind))
